<template>
  <div class="w-full flex">
    <!-- Preview for form editor -->
    <div v-if="productData == null" class="w-full flex gap-1 items-center">
      <input
          readonly
          class="outline-0 border border-trader-input-border p-1 w-full my-1 shadow-inner-2"
          :class="{ 'bg-inactive': true }"
          placeholder="Märkte auswählen"
      >
    </div>

    <!-- Fieldtype -->
    <div v-else class="w-full max-w-full flex flex-col">
      <div class="flex flex-col relative w-full">
        <input
            readonly
            placeholder="Märkte auswählen"
            class="outline-0 border border-trader-input-border p-1 w-full my-1 shadow-inner-2"
            :class="{ 'bg-inactive': readOnly }"
            @click="openMarketList"
            :value="selectedMarkets.map((m) => formatMarketTitle(m)).join(', ')"
        >

        <div v-if="showDropdown"
             class="absolute top-6 left-0 border border-trader-input-border p-1 w-full shadow-inner-2 max-h-64 bg-white overflow-auto z-10">
          <div v-for="market in activeMarkets"
               :key="market.marketId"
               class="m-1 p-2 cursor-pointer flex items-center gap-2"
               :class="{ 'bg-trader-blue text-white': selectedMarkets.some(m => m.marketId === market.marketId), 'hover:bg-trader-gray': !selectedMarkets.some(m => m.marketId === market.marketId) }"
               @click="onSelectMarket(market)">
            <!--
            <input
                type="checkbox"
                :checked="selectedMarkets.some(m => m.marketId === market.marketId)"
                class="w-4 h-4"
                @click="onSelectMarket(market)"
            > -->
            <span>{{ formatMarketTitle(market) }}</span>
          </div>
        </div>
      </div>

      <!-- Selected markets summary -->
      <div v-if="selectedMarkets.length > 0" class="mt-2 flex flex-wrap gap-2">
        <div v-for="market in selectedMarkets"
             :key="market.marketId"
             class=" px-2 py-1 rounded-md flex items-center gap-2 bg-trader-dark-gray dark:bg-trader-gray">
          <span>{{ formatMarketTitle(market) }}</span>
          <button
              v-if="!readOnly"
              @click="removeMarket(market)"
              class="text-gray-500 hover:text-gray-700 text-trader-dark-red dark:text-trader-red"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {query} from "@/graphql";
export default {
  meta: {
    name: "Market Selector",
    type: "fieldtype",
    version: "1.0.0",
    hasOptions: true,
  },
  props: {
    name: "Market Selector",
    formField: {
      type: Object,
      default: () => ({})
    },
    productData: {
      type: Object,
      default: () => ({})
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {}
    },
    getFieldValue: {
      type: Function,
      default: () => {}
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    onFormEvent: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showDropdown: false,
      markets: [],
      selectedMarkets: [],
    }
  },
  computed: {
    activeMarkets() {
      return this.markets.filter(market => market.isActive)
          .sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  methods: {
    formatMarketTitle(market) {
      return `${market.name} - ${market.description}`;
    },
    openMarketList() {
      if (!this.readOnly) {
        this.showDropdown = !this.showDropdown;
      }
    },
    onSelectMarket(market) {
      if (this.selectedMarkets.some(m => m.marketId === market.marketId)) {
        this.selectedMarkets = this.selectedMarkets.filter(m => m.marketId !== market.marketId);
      } else {
        this.selectedMarkets.push(market);
      }
      this.updateParentValue();
    },
    removeMarket(market) {
      this.selectedMarkets = this.selectedMarkets.filter(m => m.marketId !== market.marketId);
      this.updateParentValue();
    },
    updateParentValue() {
      const marketIds = this.selectedMarkets.map(m => m.marketId).join(',');
      this.onChangeProductFieldValue(this.formField.field, null, marketIds);
    },
    loadSelectedMarkets(fieldName) {
      const marketIds = this.productData.customFields[fieldName]?.value?.split(',') || [];
      const parsedIds = marketIds.map(id => parseInt(id));
      this.selectedMarkets = this.activeMarkets.filter(m => parsedIds.includes(m.marketId));
    },
    reloadSelectedMarkets() {
      this.loadSelectedMarkets(this.formField.field);
    },
  },
  async mounted() {
    if (this.productData == null) {
      return;
    }

    const [markets, err] = await query.getMarkets();
    if (err) {
      console.error('Error fetching markets:', err);
      return;
    }
    this.markets = markets;
    this.loadSelectedMarkets(this.formField.field);
    this.onFormEvent('reset', this.reloadSelectedMarkets);
  },
  created() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false;
      }
    });
  }
}
</script>